"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNZHelix = exports.getApiEndpoint = exports.getDomain = exports.getApiBaseURL = void 0;

/**
 * Generate API endpoint.
 *
 * @param {string} version
 * @param {string} appStack - If version is not v1 then appStack should be required.
 */
var getApiBaseURL = function getApiBaseURL(version, appStack) {
  var stack = appStack ? switchForNZ(appStack) + '/' : '';
  var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : 'dev';

  if (version === 'v1') {
    return getApiEndpoint(env);
  }

  return "https://liveapi." + getDomain(env) + ".com/" + stack + version;
};

exports.getApiBaseURL = getApiBaseURL;

var getDomain = function getDomain(env) {
  switch (env) {
    case 'prod':
      return 'roymorgan';

    case 'uat':
      return 'roymorganuat';

    case 'local':
    case 'dev':
    default:
      return 'roymorgandev';
  }
};
/**
 * Generate v1 API endpoint.
 *
 * @deprecated Since version 5.x.
 * Will be made private in a future version.
 * Use getApiBaseURL instead.
 */


exports.getDomain = getDomain;

var getApiEndpoint = function getApiEndpoint(appEnv) {
  var env = appEnv ? appEnv : 'dev';
  return "https://liveapi." + getDomain(env) + ".com/v1";
};

exports.getApiEndpoint = getApiEndpoint;

var isNZHelix = function isNZHelix() {
  return process.env.REACT_APP_DATA_ENDPOINT === 'nz-helix' || window.location.host.includes('nz') ? true : false;
};

exports.isNZHelix = isNZHelix;

var switchForNZ = function switchForNZ(appStack) {
  if (appStack !== 'helix') return appStack;

  if (isNZHelix()) {
    return 'nz-helix';
  }

  return 'helix';
};